import * as React from 'react'
import PropTypes from 'prop-types'

import backBtn from 'assets/images/backBtn.png'

const BackButton = ({ buttonText, buttonMethod, ...rest }) => (
  <button
    className="bg-transparent	grotesque text-sm font-normal text-tintedInputTextColor mb-6"
    onClick={buttonMethod}
    {...rest}
  >
    <img src={backBtn} className="mr-2" alt="back" />
    {buttonText}
  </button>
)

BackButton.propTypes = {
  buttonMethod: PropTypes.func.isRequired,
  buttonText: PropTypes.string,
}

BackButton.defaultProps = {
  buttonText: 'Back',
}

export default BackButton
